import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import ViewEmpShifts from "./ViewEmpShifts";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
const { Option } = Select;
import Swal from "sweetalert2";

const RollcallAssignShifts = () => {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);

  const [loadingDept, setLoadingDept] = useState(false);
  const [loadingShift, setLoadingShift] = useState(false);
  const [loadingEmp, setLoadingEmp] = useState(false);

  const [assignShiftId, setAssignShiftId] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [assignLoading, setAssignLoading] = useState(false);
  const [showViewShifts, setShowViewShifts] = useState(false);

  const filteredEmployees = employees.filter((emp) => {
    const text = employeeSearch.toLowerCase();
    return (
      emp.UserName?.toLowerCase().includes(text) ||
      emp.badge?.toString().includes(text) ||
      emp.Badge?.toString().includes(text) ||
      emp.CardId?.toString().includes(text)
    );
  });
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);
  useEffect(() => {
    setLoadingDept(true);
    fetch(
      `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((res) => setDepartments(res.ResultData || []))
      .finally(() => setLoadingDept(false));
  }, [superIdData]);

  useEffect(() => {
    setLoadingShift(true);
    fetch(
      `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((res) => setShifts(res.ResultData || []))
      .finally(() => setLoadingShift(false));
  }, [superIdData]);

  const onDepartmentChange = (deptId) => {
    setSelectedDept(deptId);
    setSelectedShift(null);
    setEmployees([]);
    setSelectedEmployees([]);
    setEmployeeSearch("");
    if (!deptId) return;

    setLoadingEmp(true);
    fetch(
      `${ROLL_CALL_API_BASE_URL}portal/department/getEmpByDept?departmentid=${deptId}&superid=${superIdData}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((res) => setEmployees(res.ResultData || []))
      .finally(() => setLoadingEmp(false));
  };

  const onShiftChange = (shiftId) => {
    setSelectedShift(shiftId);
    setSelectedDept(null);
    setEmployees([]);
    setSelectedEmployees([]);
    setEmployeeSearch("");
    if (!shiftId) return;

    setLoadingEmp(true);
    fetch(
      `${ROLL_CALL_API_BASE_URL}portal/shifts/getEmpByShift?shiftid=${shiftId}&superid=${superIdData}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((res) => setEmployees(res.ResultData || []))
      .finally(() => setLoadingEmp(false));
  };

  const toggleEmployee = (emp) => {
    setSelectedEmployees((prev) =>
      prev.some((e) => e.regid === emp.regid)
        ? prev.filter((e) => e.regid !== emp.regid)
        : [...prev, emp],
    );
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedEmployees(filteredEmployees);
    } else {
      setSelectedEmployees([]);
    }
  };

  const clearAll = () => setSelectedEmployees([]);

  const isChecked = (emp) =>
    selectedEmployees.some((e) => e.regid === emp.regid);

  const handleAssignShift = () => {
    const payload = {
      regid: selectedEmployees.map((e) => e.regid),
      shiftid: assignShiftId,
      startdate: startDate,
      enddate: endDate,
    };

    setAssignLoading(true);

    fetch(`${ROLL_CALL_API_BASE_URL}portal/shifts/assignShifts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenData}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          Swal.fire({
            icon: "success",
            title: "Shift Assigned",
            text: "Shift assigned successfully",
          });

          setSelectedEmployees([]);
          setEmployees([]);
          setAssignShiftId(null);
          setStartDate("");
          setEndDate("");
          setSelectedDept(null);
          setSelectedShift(null);
        } else {
          Swal.fire("Error", "Failed to assign shift", "error");
        }
      })
      .catch(() => {
        Swal.fire("Error", "Something went wrong", "error");
      })
      .finally(() => setAssignLoading(false));
  };

  const splitUserName = (name = "") => {
    const parts = name.split("-");
    if (parts.length < 2) return { name, badge: null };

    return {
      name: parts.slice(0, -1).join("-").trim(),
      badge: parts[parts.length - 1].trim(),
    };
  };

  return (
    <div>
      {assignLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Assign Shifts
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your employees shifts</h6>
              </div>
            </div>

            <div className="page-btn mb-3">
              <Link
                to="#"
                className="btn btn-primary"
                onClick={() => setShowViewShifts(true)}
              >
                <i className="fa-regular fa-eye"></i>
              </Link>
            </div>
          </div>
          <div className="card ">
            <div className="card-header">
              <div className="d-flex ms-auto right-content align-items-end flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <label
                    className="form-label w-100"
                    htmlFor="department-select"
                  >
                    Department
                  </label>
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 220 }}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="Select Department"
                      loading={loadingDept}
                      value={selectedDept}
                      onChange={onDepartmentChange}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {departments.map((d) => (
                        <Option key={d.DepartmentId} value={d.DepartmentId}>
                          {d.Name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="dropdown me-2 d-none">
                  <label className="form-label w-100" htmlFor="shift-select">
                    Previous Shift <span className="text-danger ms-1"></span>
                  </label>
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 250 }}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="Select Shift"
                      loading={loadingShift}
                      value={selectedShift}
                      onChange={onShiftChange}
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {shifts.map((s) => (
                        <Option key={s.shiftid} value={s.shiftid}>
                          {s.Name} ({s.StartTime} - {s.EndTime})
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className=" d-flex  ">
                <div className="col-4">
                  {loadingEmp ? (
                    <div className="text-center py-3">
                      <Spin />
                    </div>
                  ) : employees.length === 0 ? (
                    <div className="text-muted text-center">
                      No employees found
                    </div>
                  ) : (
                    <>
                      <div className="p-3">
                        <div className="mb-4 d-flex">
                          <div className="me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search employee / badge"
                              value={employeeSearch}
                              onChange={(e) =>
                                setEmployeeSearch(e.target.value)
                              }
                              disabled={loadingEmp}
                            />
                          </div>
                          <div className="d-flex ">
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={clearAll}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div
                          className=""
                          style={{
                            height: "calc(100vh - 160px)",
                            overflowY: "auto",
                          }}
                        >
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="selectAll"
                              checked={
                                filteredEmployees.length > 0 &&
                                selectedEmployees.length ===
                                  filteredEmployees.length
                              }
                              onChange={handleSelectAllChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="selectAll"
                              style={{ cursor: "pointer" }}
                            >
                              Select All
                            </label>
                          </div>

                          {filteredEmployees.length === 0 ? (
                            <div className="text-muted text-center">
                              No employees found
                            </div>
                          ) : (
                            filteredEmployees.map((emp) => {
                              const checkboxId = `emp-${emp.regid}`;

                              return (
                                <div
                                  className="form-check pb-2"
                                  key={emp.regid}
                                >
                                  <input
                                    id={checkboxId}
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isChecked(emp)}
                                    onChange={() => toggleEmployee(emp)}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={checkboxId}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {(() => {
                                      const { name, badge } = splitUserName(
                                        emp.UserName,
                                      );

                                      return (
                                        <div className="fw-medium d-flex align-items-center gap-2">
                                          <div>{name}</div>
                                          {badge && (
                                            <span className="badge bg-secondary">
                                              {badge}
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </label>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-4">
                  <div className=" border h-100 border-end-0 border-bottom-0 border-top-0 p-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="">Selected Employees</div>
                    </div>
                    <hr />
                    <div
                      className=""
                      style={{
                        height: "calc(100vh - 160px)",
                        overflowY: "auto",
                      }}
                    >
                      {selectedEmployees.length === 0 ? (
                        <div className="text-muted">No employees selected</div>
                      ) : (
                        <ul className="list-group list-group-flush">
                          {selectedEmployees.map((emp) => (
                            <li
                              key={emp.regid}
                              className="list-group-item d-flex justify-content-between align-items-center py-1"
                            >
                              {(() => {
                                const { name, badge } = splitUserName(
                                  emp.UserName,
                                );

                                return (
                                  <div className="fw-medium d-flex align-items-center gap-2">
                                    <span>{name}</span>
                                    {badge && (
                                      <span className="badge bg-secondary">
                                        {badge}
                                      </span>
                                    )}
                                  </div>
                                );
                              })()}

                              <button
                                className="btn btn-sm btn-outline-danger"
                                title="Remove"
                                onClick={() =>
                                  setSelectedEmployees((prev) =>
                                    prev.filter((e) => e.regid !== emp.regid),
                                  )
                                }
                              >
                                <i className="fa-solid fa-trash-can"></i>{" "}
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" border h-100 border-end-0 border-bottom-0 border-top-0 p-3">
                    <label className="form-label">Shift</label>
                    <Select
                      showSearch
                      placeholder="Select Shift"
                      value={assignShiftId}
                      onChange={setAssignShiftId}
                      style={{ width: "100%" }}
                    >
                      {shifts.map((s) => (
                        <Select.Option key={s.shiftid} value={s.shiftid}>
                          {s.Name} ({s.StartTime} - {s.EndTime})
                        </Select.Option>
                      ))}
                    </Select>

                    <div className="row mt-3 mb-2">
                      <div className="col-md-6">
                        <label className="form-label">Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-primary"
                        disabled={
                          assignLoading ||
                          !assignShiftId ||
                          !startDate ||
                          !endDate ||
                          selectedEmployees.length === 0
                        }
                        onClick={handleAssignShift}
                      >
                        {assignLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Assigning...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      <ViewEmpShifts
        isOpen={showViewShifts}
        onClose={() => setShowViewShifts(false)}
      />
    </div>
  );
};

export default RollcallAssignShifts;
